import styles from './EbcAnalysisInProgress.module.css';
import ebc from "./assets/images/EBC.png";

function EbcAnalysisInProgress() {
  return (
    <div className={styles.fullContainer}>
      <div className={styles.card}>
        <img src={ebc} className={styles.ebcLogo} alt="EBC Logo" />
        <h1 className={styles.title}>Analysis In Progress</h1>
        <p className={styles.body}>
          The EBC analytical results for this batch are currently being processed.
          Please check back soon.
        </p>
      </div>
    </div>
  );
}

export default EbcAnalysisInProgress;
